import {Box, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {AppointmentBookingEnum, FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {CardList, SelectLocationContainer, StyledGrid} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';

import {Loading} from 'presentation/components/Loading/Loading';

import {BookingNotFoundVariantEnum} from 'presentation/pages/private/booking/components/BookingNotFoundDialog/types';

import {BookingEmptyState} from '../../../../components/BookingEmptyState';
import {BookingErrorState} from '../../../../components/BookingErrorState';
import {BookingNotFoundDialog} from '../../../../components/BookingNotFoundDialog';
import {LocalitiesListProps} from './types';

import {LocalitiesNotFoundState} from '../LocalitiesNotFoundState';
import {useLocalitiesList} from './hooks/useLocalitiesList';
import {normalizeText} from 'presentation/utils/normalizeText';

const {locality, emptySearchState} = translations['pt-br'].privateFlow.profile.locationSelection;
const {selectLocality} = translations['pt-br'].commons;

export function LocalitiesList({flowType}: LocalitiesListProps) {
	const {
		loadingList,
		localitiesList,
		localitiesListError,
		handleConfirmSelection,
		notFoundModalIsOpen,
		setNotFoundModalIsOpen,
		handleCallChatRoom,
		handleGuideNav,
		isListEmpty,
		NOT_FOUND,
		refetch,
		isMobile,
	} = useLocalitiesList({flowType});

	if (loadingList) {
		return <Loading minHeight="50%" text={locality.loadingRegions} />;
	}

	if (localitiesListError) {
		return (
			<BookingErrorState
				errorTitle={locality.loadingError}
				handleRefresh={refetch}
				showHeader={false}
			/>
		);
	}

	if (NOT_FOUND) {
		return (
			<Box p={isMobile ? 2 : 4} mt={2}>
				<LocalitiesNotFoundState flowType={flowType} />
			</Box>
		);
	}

	return (
		<Fragment>
			{isListEmpty ? (
				<BookingEmptyState
					description={emptySearchState.notfoundAllLocality}
					internalPadding
					flowType={flowType}
					dataTagId={FinishWithoutCompleteFlowEnum.SEM_LOCALIDADE_ENCONTRADA}
				/>
			) : (
				<SelectLocationContainer
					customOrientationText={locality.orientationRegion}
					buttonDataTagId={AppointmentBookingEnum.CLICK_NAO_ENCONTREI_CIDADE_DESEJADA}
					handleOpenModal={() => setNotFoundModalIsOpen(true)}
					flowType={flowType}>
					<Typography variant="subtitle2" color="text.secondary">
						{selectLocality}
					</Typography>

					<StyledGrid.Root>
						{localitiesList?.map((item, index) => (
							<StyledGrid.Item
								sm={12}
								md={12}
								lg={localitiesList?.length > 1 ? 6 : 12}
								key={`${item.nmLocal}-${index}`}>
								<CardList
									dataTagId={`${AppointmentBookingEnum.SELECIONOU_CIDADE}${normalizeText(item?.nmLocal)}`}
									handleClick={() => {
										handleConfirmSelection(item);
									}}
									text={formatText(item.nmLocal)}
									showArrowRightIcon
									selected={false}
								/>
							</StyledGrid.Item>
						))}
					</StyledGrid.Root>
				</SelectLocationContainer>
			)}

			<BookingNotFoundDialog
				headerModalDataTagId={AppointmentBookingEnum.VISUALIZOU_MODAL_NAO_ENCONTREI_CIDADE}
				closeModalDataTagId={AppointmentBookingEnum.CLICK_FECHAR_MODAL_NAO_ENCONTREI_CIDADE}
				firstActionDataTagId={
					AppointmentBookingEnum.CLICK_CONSULTAR_REDE_MODAL_NAO_ENCONTREI_CIDADE
				}
				secondActionDataTagId={
					AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_MODAL_NAO_ENCONTREI_CIDADE
				}
				flowType={flowType}
				variant={BookingNotFoundVariantEnum.LOCALITY}
				handleCallChatRoom={handleCallChatRoom}
				handleGuideNav={handleGuideNav}
				open={notFoundModalIsOpen}
				setOpen={setNotFoundModalIsOpen}
			/>
		</Fragment>
	);
}
